import React from 'react'

function Social() {
  return (
    <div className='home__social'>
        <a href="https://github.com/boymeetsblockchain" className='home__social-icon' rel='noreferrer' target="_blank"> 
         <i class='uil uil-github-alt'></i>
        </a>
        <a href="https://twitter.com/i_am_hasashi" className='home__social-icon'  rel='noreferrer' target="_blank"> 
         <i class='uil uil-twitter-alt'></i>
        </a>
        <a href="https://www.linkedin.com/in/oluwasegun-aje-b990a1232/" className='home__social-icon'  rel='noreferrer' target="_blank"> 
         <i class='uil uil-linkedin-alt'></i>
        </a>
    </div>
  )
}

export default Social